import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class Pie extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'pie'
            },
            tooltip: {
                formatter: function () {
                    return `${this.key}: <b>${this.y}</b>`;
                }
            }
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Pie)}
